<template>
  <div class="login-wrap">
    <vue-element-loading
      :active="isActive"
      spinner="bar-fade-scale"
      class="spanner"
      color="rgb(64, 158, 255)"
      text=""
    />
    <el-form
      v-if="login && !isActive"
      label-position="top"
      :model="ruleForms"
      :rules="rule"
      ref="ruleForms"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">
        <img src="@/assets/img/logo1.jpg" alt="" />
        欢迎登录舒誉
      </h3>
      <el-form-item prop="username" label="用户名">
        <el-input
          type="text"
          v-model="ruleForms.username"
          auto-complete="off"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="ruleForms.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="code">
            <el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="图形验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="code-box">
          <img :src="ruleForm.codeimg" alt="" class="codeimg" @click="getcode()">
        </el-col>
      </el-row> -->
      <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
      <el-form-item style="width: 100%">
        <div class="btn_box">
          <el-button
            type="primary"
            @click="submitForm('ruleForms')"
            :loading="logining"
            >立即登录</el-button
          >
        </div>
        <!-- <div class="btn_box" style="margin: 0">
          <el-link type="primary" @click="register">立即注册</el-link>
        </div> -->
      </el-form-item>
    </el-form>
    <el-form
      v-if="!login"
      label-position="top"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      style="width: 792px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">
        <img src="@/assets/img/logo1.jpg" alt="" />欢迎注册壹嘉录单系统
      </h3>
      <div class="input_box">
        <el-form-item
          prop="userName"
          label="用户名"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-input
            type="text"
            v-model="ruleForm.userName"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item
          auto-complete="off"
          label="密码"
          prop="password"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="(由字母和数字组成)"
          ></el-input>
        </el-form-item>
      </div>
      <div class="input_box">
        <!-- <el-form-item
          prop="username"
          label="真实姓名"
          style="flex: 1; margin: 0 24px"
        >
          <el-input
            type="text"
            v-model="ruleForm.username"
            auto-complete="off"
            placeholder="(必须与Canada ID上一致)"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          prop="weChat"
          type="text"
          label="微信账号"
          style="flex: 1; margin: 20px 24px"
        >
          <el-input
            type=""
            v-model="ruleForm.weChat"
            auto-complete="off"
            placeholder="微信账号"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          prop="canadaPhoneNumber"
          label="加拿大电话"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-input
            v-model.number="ruleForm.canadaPhoneNumber"
            autocomplete="off"
            placeholder="(xxx-xxxxxxxx)"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="chinaPhoneNumber"
          label="中国电话"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-input
            v-model.number="ruleForm.chinaPhoneNumber"
            auto-complete="off"
            placeholder="(xxxxxxxxxx)"
          ></el-input>
        </el-form-item>
      </div>
      <div class="input_box">
        <el-form-item
          prop="belongsUserName"
          label="所属销售代表"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-select
            :disabled="!isData"
            @change="selectUser"
            style="width: 100%"
            v-model="ruleForm.belongsUserName"
            clearable
            placeholder="选择销售代表"
          >
            <el-option
              v-for="item in userData"
              :key="item.id"
              :label="item.realName"
              :value="JSON.stringify(item)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="pickUpLocation"
          label="取货地点"
          style="flex: 1; margin: 20px 24px 0"
        >
          <el-select
            :disabled="!isAddress"
            @change="selectUserLocation"
            style="width: 100%"
            v-model="ruleForm.pickUpLocation"
            clearable
            placeholder="取货地点"
          >
            <el-option
              v-for="item in address"
              :key="item.id"
              :label="item.name + '-' + item.detailArea"
              :value="JSON.stringify(item)"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="input_box"></div>

      <el-form-item style="width: 100%; margin-top: 40px">
        <div class="btn_box">
          <el-button
            :loading="loginings"
            type="primary"
            @click="submitForms('ruleForm')"
            >立即注册</el-button
          >
        </div>
        <div class="btn_box" style="margin: 0">
          <el-link type="primary" @click="logins">立即登录</el-link>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import crudDept from "../api/userMG";
import Cookies from "js-cookie";
import Config from "@/settings";
import VueElementLoading from "vue-element-loading";
import { setCookie, getCookie, delCookie } from "../utils/util";
import md5 from "js-md5";
export default {
  name: "login",
  components: {
    VueElementLoading,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value) {
        if (value.toString().length != 10 || value < 1) {
          callback(new Error("请输入正确的加拿大号码"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入加拿大号码"));
      }
    };
    return {
      isActive: false,
      loginings: false,
      address: ["密市总仓", "北部总仓", "销售代表"],
      options: [],
      login: true,
      //定义loading默认为false
      logining: false,
      addressList: [],
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        belongsUserName: "",
        weChat: "",
        canadaPhoneNumber: "",
        chinaPhoneNumber: "",
        userName: "",
        password: "",
        pickUpLocationId: "",
        pickUpLocation: "",
      },
      ruleForms: {
        username: "",
        password: "",
      },
      //rules前端验证
      rules: {
        belongsUserName: [
          { required: true, message: "请选择销售代表", trigger: "blur" },
        ],
        pickUpLocation: [
          { required: true, message: "请选择取货地点", trigger: "blur" },
        ],
        weChat: [{ required: true, message: "微信账号", trigger: "blur" }],

        canadaPhoneNumber: [
          { required: true, trigger: "blur", validator: checkPhone },
          // {message: "请输入正确的电话格式", trigger: "blur", },
        ],
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码最少为6位数", trigger: "blur" },
        ],
      },
      rule: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      userData: [],
      timer: null,
      isData: false,
      isAddress: false,
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
         
    var token = this.$route.query.token;  
    if (token) {
      this.isActive = true;
      Cookies.set("logistics_accessToken", token, {
        expires: Config.passCookieExpires,
      });
      if (this.$route.query.id) {
        this.userInfo(this.$route.query.id);
      }
    }else{
      window.location.href='/login?login=1&jumpLogin=1'
    }
  },
  // 里面的函数只有调用才会执行
  methods: {
    userInfo(id) {
      var that = this;
      var data = {
        id: id,
      };
      crudDept.getUser(data).then((res) => {
        var users = {
          id: res.id,
        };

        Cookies.set("logistics_user", users, {
          expires: Config.passCookieExpires,
        });
        this.$store.commit("login", "true");

        that.isActive = false;
        that.$router.push({ path: "/home/home" });
      });
    },
    logins() {
      if (!this.loginings) {
        this.login = true;
      }
    },
    //点击注册
    register() {
      if (!this.logining) {
        this.login = false;
        this.user();
        this.pickUpLocations();
      }
    },
    selectUserLocation(e) {
      e = JSON.parse(e);
      this.ruleForm.pickUpLocationId = e.id;
      this.ruleForm.pickUpLocation = e.name;
    },
    //自提点列表
    pickUpLocations() {
      var data = {
        category: 0,
        sort: "number,asc",
      };
      crudDept.pickUpLocation(data).then((res) => {
        this.isAddress = true;
        this.address = res.content;
        this.addressList = res.content;
      });
    },
    pickUpLocationss(belongsToId) {
      var data = {
        belongsToId: belongsToId,
        category: 1,
        sort: "number,asc",
      };
      crudDept.pickUpLocation(data).then((res) => {
        // var list=res.content;
        // list.forEach(element => {
        //    const matched = userRoute.find(
        //       ({ routeid }) => routeid === res.content[j].id
        //     );
        // });

        for (var i = 0; i < res.content.length; i++) {
          if (!this.addressList.includes(res.content[i])) {
            this.address.push(res.content[i]);
          }
        }
      });
    },
    //选择销售代表
    selectUser(e) {
      if (this.userData == "" && !isData) {
        this.user();
      }
      this.ruleForm.pickUpLocation = "";
      e = JSON.parse(e);
      this.ruleForm.belongsUserId = e.id;
      this.ruleForm.belongsUserName = e.realName;
      this.address = [];
      // this.address = this.addressList;
      this.pickUpLocations();
      setTimeout(() => {
        this.pickUpLocationss(e.id);
      }, 1000);
    },
    //销售代表类表
    user() {
      var data = {
        role: 2,
        page: 1,
        size: 500,
      };
      crudDept.user(data).then((res) => {
        this.userData = res.content;
        this.isData = true;
      });
    },
    point() {
      const point = Cookies.get("point") !== undefined;
      if (point) {
        this.$notify({
          title: "提示",
          message: "当前登录状态已过期，请重新登录！",
          type: "warning",
          duration: 5000,
        });
        Cookies.remove("point");
      }
    },
    // getCode() {
    //   getCodeImg().then((res) => {
    //     this.codeUrl = res.img;
    //     this.loginForm.uuid = res.uuid;
    //   });
    // },
    // 获取用户名密码
    getCookie() {
      // const username = Cookies.get("username");
      // let password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      // 保存cookie里面的加密后的密码
      this.cookiePass = password === undefined ? "" : password;
      password = password === undefined ? this.loginForm.password : password;
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        code: "",
      };
    },
    //d登录
    anginLogin() {
      var t = this;

      this.timer = setInterval(() => {
        if (!t.isLogin) {
          t.$message.error("连接超时，请重新登录！");
          t.logining = false;
          t.isLogin = true;
          t.$forceUpdate();
          // t.submitForm('ruleForms');
        }
      }, 15000);
    },
    submitForm(formName) {
      this.isLogin = false;
      Cookies.remove("logistics_accessToken");
      Cookies.remove("logistics_refreshToken");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          // this.anginLogin()

          crudDept
            .login(this.ruleForms)
            .then((res) => {
              this.isLogin = true;
              clearInterval(this.timer);

              setTimeout(() => {
                Cookies.set("logistics_accessToken", res.accessToken, {
                  expires: Config.passCookieExpires,
                });
                Cookies.set("logistics_refreshToken", res.refreshToken, {
                  expires: Config.passCookieExpires,
                });
                Cookies.set("logistics_user", res.user, {
                  expires: Config.passCookieExpires,
                });
                this.logining = false;
                this.$store.commit("login", "true");
                this.$refs[formName].resetFields();
                this.$router.push({ path: "/home/home" });
              }, 1000);
            })
            .catch((err) => {
              clearInterval(this.timer);
              // this.$message.error("请重新登录！");
              this.logining = false;
            });
        } else {
          this.$message.error("请输入用户名密码！");
          clearInterval(this.timer);
          this.logining = false;
        }
      });
    },
    //注册
    submitForms(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginings = true;

          crudDept
            .sign(that.ruleForm)
            .then((res) => {
              that.$alert("注册成功啦", "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  that.login = true;
                  that.loginings = false;
                  that.$refs[formName].resetFields();
                },
              });
            })
            .catch((err) => {
              that.loginings = false;
            });
        } else {
          that.loginings = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap >>> .el-form--label-top .el-form-item__label {
  padding: 0 !important;
}
.input_box {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.btn_box {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 5%;
  background-image: url("../assets/img/bj.png");
  background-repeat: no-repeat;
  /* background-position: center right; */
  background-size: cover;
}
.login-container {
  /* border-radius: 10px; */
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title img {
  /* width: 36px; */
  height: 37px;
  margin-right: 10px;
  object-fit: cover;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue